export default __webpack_public_path__ + "static/media/miningdata.1d0baf6d.svg";